/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export interface Control {
  type: string;
  value?: string;
}

export enum ControlType {
  Remove = 'Remove',
  Operator = 'Operator',
  Function = 'Function',
}

export interface Element {
  id: number;
  slug: string;
  title: string;
}

export enum FormulaBlockType {
  Operator = 'Operator',
  Variable = 'Variable',
  Function = 'Function',
}

export enum VariableType {
  Factor = 'Factor',
  Vector = 'Vector',
  Score = 'Score',
}

export interface Variable {
  type: FormulaBlockType;
  variableType: VariableType;
  value: string;
  slug: string;
}

export interface Operator {
  type: FormulaBlockType;
  value: string;
}

export interface Function {
  type: FormulaBlockType;
  value: string;
  values: Array<Variable | Operator>;
}

export interface CalculationBuilderData {
  controls: Array<Control>;
  elements: { factors: Element[]; vectors: Element[]; scores: Element[] };
  formula: string;
  formulaWithSlugs: string;
}
